export default [
  {
    path: "/active-bookings",
    name: "ActiveBookings",
    component: () => import("@/views/Ondemand/ActiveBookings.vue"),
  },
  {
    path: "/historical-bookings",
    name: "HistoricalBookings",
    component: () => import("@/views/Ondemand/HistoricalBookings.vue"),
  },
  {
    path: "/new-booking",
    name: "NewBooking",
    component: () => import("@/views/3pl/Operations/Bookings/NewBooking.vue"),
  },
  {
    path: "/shipment-track",
    name: "QuotesAndDrafts",
    component: () => import("@/views/Ondemand/ShipmentTracking.vue"),
  },
  {
    path: "/quote-draft",
    name: "QuoteAndDraft",
    component: () => import("@/views/Ondemand/QuoteDraft.vue"),
  },
  {
    path: "/new-quote-draft",
    name: "NewQuoteAndDraft",
    component: () => import("@/views/Ondemand/Qoute/NewQuoteAndDraft.vue"),
  },
  {
    path: "/describe-quote-draft",
    name: "DescribeQuoteAndDraft",
    component: () => import("@/views/Ondemand/Qoute/DescribeShippment.vue"),
  },
  {
    path: "/quote-refrence",
    name: "QuoteRefrence",
    component: () => import("@/views/Ondemand/Qoute/QuoteRefrence.vue"),
  },
  {
    path: "/booking-flow",
    name: "BookingFlow",
    component: () => import("@/views/Ondemand/booking/BookingFlows.vue"),
  },
  {
    path: "/booking-flow-details/:id",
    name: "BookingFlowDetails",
    component: () => import("@/views/Ondemand/booking/BookingDetails.vue"),
  },
  {
    path: "/booking-flow-rating/:id",
    name: "BookingFlowRating",
    component: () => import("@/views/Ondemand/booking/RatingAction.vue"),
  },
  {
    path: "/booking-flow-claim/:id",
    name: "BookingFlowClaim",
    component: () => import("@/views/Ondemand/Claim/Claims.vue"),
  },
  {
    path: "/booking-direction/:id",
    name: "BookingDirection",
    component: () => import("@/views/Ondemand/booking/BookingDirection.vue"),
  },
];
